import { PsHttpService } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { GuestTaskApi } from '../guest-task-api';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';

/**
 * 游客任务 API 实现
 */
@injectable()
export class GuestTaskApiImpl extends PsHttpService implements GuestTaskApi {
    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    async refreshGuestTasks(): Promise<void> {
        await this.post({
            url: 'ai/task/user-transform',
        });
    }
}
